import React, { useState } from 'react'

import { bool, func, object } from 'prop-types'
import { branch } from 'baobab-react/higher-order'
import getNewIcon from 'utils/getNewIcon'
import { MENU_ITEMS } from 'components/utils/constants/MenuItems'
import { PROFILE_MENU_ITEMS } from 'components/utils/constants/ProfileMenuItems'
import triggerEvent from 'utils/dataLayer'

import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography'
import LikeButton from 'components/molecules/LikeButton'
import ShareButton from 'components/molecules/ShareButton'
import NewSearch from 'components/organisms/NewSearch'
import NotificationMenu from 'components/notifications/organisms/NotificationMenu'
import NotificationPopover from 'components/notifications/organisms/NotificationPopover'

import config from 'config'

// eslint-disable-next-line import/no-named-as-default
import MenuItem from './MenuItem'
import UnauthorizedMenu from './UnauthorizedMenu'
import PopupMenu from './PopupMenu'

const { assets_url: assetsUrl } = config

const Navbar = ({ currentUser, actionContent, showMobileNotification, hideMobileNotification }) => {
  const [displaySearch, setDisplaySearch] = useState(false)
  const [menuState, setMenuState] = useState('idle')
  const toggleSearch = () => {
    if (displaySearch) {
      setDisplaySearch(false)
    } else {
      setDisplaySearch(true)
    }
  }
  const toggleDirectoryMenu = () => {
    setMenuState(menuState !== 'directory' ? 'directory' : 'idle')
  }
  const toggleDisplayProfileMenu = () => {
    setMenuState(menuState !== 'profile' ? 'profile' : 'idle')
  }
  const toggleNotification = () => {
    setMenuState(menuState !== 'notification' ? 'notification' : 'idle')
  }
  const ProfileUnauthorizedMenuItems = [
    {
      url: '/signup',
      name: 'Daftar',
      label: 'signup',
    },
    {
      url: '/signin',
      name: 'Masuk',
      label: 'signin',
    },
  ]
  const ProfileAuthorizedMenuItems = [
    {
      url: '/profile',
      imageUrl: 'assets/img/avatar.png',
      name: (currentUser && currentUser.first_name) || '',
      label: 'profile',
    },
    ...PROFILE_MENU_ITEMS,
  ]
  return (
    <div className="navbar navbar--new">
      <Container next>
        <div className="navbar--new__content">
          <div className="navbar--new__navigation" onClick={toggleSearch} >
            {getNewIcon('arrow-left')}
          </div>
          <div className="navbar--new__brand">
            <a href="/" onClick={() => triggerEvent('ga/global/button-navbar/home')}>
              <picture>
                <source srcSet={`${assetsUrl}/assets/img/logo/qc_logo_c.svg`} media="(min-width: 768px)" />
                <img
                  src={`${assetsUrl}/assets/img/logo/qc_small_logo_gradient.png`}
                  alt="Info Kampus Terlengkap dan Berkualitas | Quipper Campus"
                />
              </picture>
            </a>
          </div>
          <div className="desktop-menu" onMouseEnter={toggleDirectoryMenu} onMouseLeave={toggleDirectoryMenu}>
            <MenuItem label="Direktori" iconName="menu" onClick={() => triggerEvent('ga/global/button-navbar/directory')}/>
            {menuState === 'directory' && <PopupMenu items={MENU_ITEMS} close={toggleDirectoryMenu} />}
          </div>
          <NewSearch displayAutocomplete={displaySearch} sideEffect={toggleSearch} />
          {!hideMobileNotification && (
            <div onClick={showMobileNotification} className="notification-mobile-menu">
              <NotificationMenu />
            </div>
          )}
          { !currentUser && (
            <>
              <div
                className="notification-menu-item"
                onMouseEnter={toggleNotification}
                onMouseLeave={toggleNotification}
              >
                <NotificationMenu isActive={menuState === 'notification'} />
                {menuState === 'notification' && <NotificationPopover close={() => setMenuState('idle')} />}
              </div>
              <UnauthorizedMenu />
            </>
          ) }
          { currentUser &&
            <div className="authorized-menu">
              <MenuItem
                label="Riwayat Tes"
                iconName="assessmentHistory"
                url="/aptitude_test/history"
                onClick={() => triggerEvent('ga/global/button-navbar/history')}
                checkTerms
              />
              <MenuItem
                label="Favorit"
                iconName="heartOutline"
                url="/likes/schools"
                onClick={() => triggerEvent('ga/global/button-navbar/favourite')}
              />
              <div className="notification-menu-item" onMouseEnter={toggleNotification} onMouseLeave={toggleNotification}>
                <NotificationMenu isActive={menuState === 'notification'} />
                {menuState === 'notification' && <NotificationPopover close={() => setMenuState('idle')} />}
              </div>
              <div
                className="profile-menu-item"
                onMouseEnter={toggleDisplayProfileMenu}
                onMouseLeave={toggleDisplayProfileMenu}
                onClick={() => triggerEvent('ga/global/button-navbar/profile')}
              >
                <img src={`${assetsUrl}/assets/img/avatar.png`} alt="Profile Avatar" />
                <Typography className="profile-name" variant="subbody" fontWeight="bold" component="span">
                  {currentUser.first_name}
                </Typography>
                {menuState === 'profile' && <PopupMenu items={currentUser ? ProfileAuthorizedMenuItems : ProfileUnauthorizedMenuItems} close={toggleDisplayProfileMenu} />}
              </div>
            </div>
          }
          {
            actionContent &&
            <div className="navbar--new__action">
              {
                actionContent.shareTitle &&
                <ShareButton
                  title={actionContent.shareTitle}
                  shareText={actionContent.shareText}
                  forNavbar
                />
              }
              {
                actionContent.likeTarget &&
                <LikeButton
                  active={actionContent.likeStatus}
                  kind={actionContent.kind}
                  targetId={actionContent.likeTarget}
                  type={actionContent.type}
                  forNavbar
                  forDetailPage
                  useNewIcon
                  handleClick={() => {
                    actionContent.kind === 'professions' && triggerEvent('career_favourite', {
                      career_name: actionContent.targetName,
                      favorite_button_location: 'sticky',
                      page_location: window.location.pathname,
                    })
                  }}
                />
              }
            </div>
          }
        </div>
      </Container>
      <style jsx>
        {`
          .navbar {
            &--new {
              width: 100%;
              height: 78px;
              position: fixed;
              top: 0;
              z-index: 99;
              background-color: #fff;

              border-top: solid 4px #2440a4;
              border-image: linear-gradient(to right, #00beff, #0fc3c4) 1 0 0 !important;
              box-shadow: 0 2px 12px 0 rgba(26, 52, 79, 0.1) !important;
              @media screen and (min-width: 768px) {
                height: 78px;
              }
              &__action {
                display: flex;
                :global(.button) {
                  margin: 0 0 0 16px !important;
                }
                @media screen and (min-width: 768px) {
                  display: none;
                }
              }
              &__content {
                height: 100%;
                padding: 22px 0;

                display: flex;
                align-items: center;
                @media screen and (min-width: 768px) {
                  padding: 16px 0;
                }
                .desktop-menu {
                  position: relative;
                  display: none;
                  padding: 12px 0;
                  @media screen and (min-width: 768px) {
                    display: unset;
                    :global(.navbar-menu-item) {
                      margin: 0 44px;
                    }
                  }
                }
                .notification-mobile-menu {
                  margin-left: 16px;
                  @media screen and (min-width: 768px) {
                    display: none;
                  }
                }
                .notification-menu-item {
                  position: relative;
                  margin-left: ${currentUser ? '8px' : '0'};
                  margin-right: ${!currentUser ? '40px' : '0'};
                  display: none;
                  @media screen and (min-width: 768px) {
                    display: block;
                  }
                }
              }
              &__brand {
                display: ${displaySearch ? 'none' : 'block'};
                margin: 0;
                @media screen and (min-width: 768px) {
                  display: block;
                }
                img {
                  width: 24px;
                  height: unset;
                  margin-right: 16px;
                  @media screen and (min-width: 768px) {
                    width: unset;
                    height: unset;
                    margin-right: 0;
                  }
                }
              }

              &__navigation {
                margin-right: 16px;
                width: 24px;
                height: unset;
                
                display: flex;
                align-items: center;
                justify-content: center;
                display: ${displaySearch ? 'block' : 'none'};
                @media screen and (min-width: 768px) {
                  display: none;
                }
              }
              .authorized-menu {
                display: none;
                @media screen and (min-width: 768px) {
                  display: flex;
                }
              }
              .profile-menu-item {
                position: relative;
                display: flex;
                align-items: center;
                margin-left: 40px;
                cursor: pointer;

                :global(.profile-name) {
                  color: #7D92A9;
                }

                &:hover {
                  :global(.profile-name) {
                    color: #7D92A9;
                  }
                }
                img {
                  width: 28px;
                  height: 28px;
                  margin-right: 12px;
                }
              }
            }
          }
        `}
      </style>
    </div>
  )
}


Navbar.propTypes = {
  currentUser: object,
  showMobileNotification: func,
  actionContent: object,
  hideMobileNotification: bool,
}

export default branch({
  currentUser: ['serverProps', 'currentUser'],
  schoolId: ['serverProps', 'school', 'id'],
}, Navbar)
